import styles from './App.less';
import RenderRoutes from './router/router';

function App() {
  return (
    <div className={styles.app}>
      <RenderRoutes />
    </div>
  );
}

export default App;
